export default "__VITE_ASSET__BgK5XPVo__"